import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import { save, destroy }        from "apps/actions/common";
import {
  Global,
  LineMenu
} from '../model';
import {
  PLANNER_CLICK_LINE_MENU,
  PLANNER_CLICK_REMOVE_LINE,
  PLANNER_CLICK_ADD_LINE
} from 'apps/events';
import PlannerControllerBase from './base';
export default class LinesController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_CLICK_LINE_MENU, (e) => { this.onClickLineMenu(e) });
    this.customEvent(PLANNER_CLICK_REMOVE_LINE, (e) => { this.onClickRemoveLine(e) });
    this.customEvent(PLANNER_CLICK_ADD_LINE, (e) => { this.onClickAddLine(e) });
  }
  // 空いている日付のセルがクリックされた
  onClickLineMenu(e){
    let lineMenu = e.detail;
    this.updateData({
      black_over: {
        show: true
      }
    });
    this.updatePlanner({
      orders_planner: {
        lineMenu: lineMenu
      }
    });
  }
  // 製造ラインの削除ボタンが押された
  onClickRemoveLine(e){
    let lineMenu:LineMenu = Global.getPlannerData().lineMenu;
    if(!lineMenu) { return; }
    let lineId = lineMenu.lineId;

    let orderData = lineMenu.orderData()
    let lines = orderData.lines;
    if(!lines){ lines = []; }
    lines = lines.filter(id => id !== lineMenu.lineId);
    let newVal = {};
    let orderId = Global.dataScopeOrder(orderData.id)
    newVal[orderId] = { lines: null };
    this.updateOrders(newVal);
    let payload = Global.getMenuPayloads().remove_line;
    payload['url'] = payload.base_url.replace('0', lineId);
    payload['params'] = { lineId: lineId };
    App.store.dispatch(destroy(payload));
    this.closeMenu();
  }
  //　製造ラインの地下ボタンが押された
  onClickAddLine(e){
    let lineMenu:LineMenu = Global.getPlannerData().lineMenu;
    if(!lineMenu) { return; }
    let lineId = lineMenu.lineId;
    let payload = Global.getMenuPayloads().add_line;
    payload['params'] = { previous_line_id: lineId };
    App.store.dispatch(save(payload));
    this.closeMenu();
  }
  private closeMenu(){
    this.updateData({
      black_over: {
        show: false
      }
    });
    this.updatePlanner({
      orders_planner: {
        lineMenu: null
      }
    });
  }
}
